import apiClient from '@/lib/api';
import { LoginRequest, LoginResponse } from '@/types/auth';

export const authApi = {
  login: (credentials: LoginRequest): Promise<LoginResponse['data']> => {
    return apiClient.post('/api/users/login', {
      email_address: credentials.email,
      password: credentials.password,
    }).then(res => {
      // Backend returns { data: { token, role, userId } }
      return res.data.data;
    });
  },
  
  logout: (userId: string): Promise<void> => {
    return apiClient.post(`/api/users/${userId}/logout`).then(() => undefined);
  },
};
